/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import { formatReceivedValues } from 'utils/formatValues';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import { checkToken } from 'api/utils';
import { getDeducciones } from 'api/nominas/deducciones/deducciones';
import { getNominasPlazasDeducciones } from 'api/nominas/calculosDeNominaEncabezado';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

const TablaDeducciones = ({ nominaPlaza }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [deducciones, setDeducciones] = useState([]);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        importe_deduccion: e?.importe,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  useEffect(() => {
    let mounted = true;
    if (nominaPlaza) {
      const fetchAll = async () => {
        setLoading(true);
        await checkToken();
        const [
          _deducciones,
          _data,
        ] = await Promise.all([
          getDeducciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getNominasPlazasDeducciones({ nomina_plaza: nominaPlaza }),
        ]);
        const filteredData = _data.filter((e) => e.importe > 0);
        if (mounted) {
          setDeducciones(_deducciones);
          setData(formatReceivedClone(filteredData));
          setLoading(false);
        }
      };
      fetchAll();
    } else {
      setData([]);
    }
    return () => { mounted = false; };
  }, [nominaPlaza]);

  const columns = [
    {
      titleText: 'Deducciones',
      dataIndex: 'deduccion',
      key: 'deduccion',
      width: 250,
      render: (val) => {
        const _deduccion = deducciones.find((e) => e.id === val);
        return `${_deduccion?.clave || ''} - ${_deduccion?.concepto || ''}`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe_deduccion',
      key: 'importe_deduccion',
      width: 250,
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          allowExportPDF={false}
        />
      </Spin>
    </Row>
  );
};

export default TablaDeducciones;
